import { Injectable } from "@angular/core";

@Injectable()
export class SottomissioneReqBody {
    idSottomissione: string = "";
    protocollo: string = "";
}